








































































 import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
 import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import SeverUrl from "@/lib/url";
  @Component
export default class ImportBankListViews extends AbpBase {
  @Prop({type:Boolean,default:false}) value:boolean;
  currentModel = { importFile: [] };
  rdoImport="0";
  formRef = "upload-form";
  headers={
    'Content-Type': 'multipart/form-data'     
  }
  tableData=[];
  fileId="";
  loading=false;
  headerConfig={Authorization: "Bearer " + window.abp.auth.getToken()};
  postAction=SeverUrl+"api/services/app/Project/UpLoadHzbList";
  visibleChange(value) {
    if (!value) {
      (this.$refs[this.formRef] as any).resetFields();
      this.currentModel.importFile = [];
      this.tableData=[];
      this.$emit('input',false);
    }
  }
  onChange(file, fileList) {
      let typeArray = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      let isExcel = typeArray.indexOf(file.raw.type)
      if (isExcel === -1) {
        this.$message.error('上传文件必须是Excel格式');
        fileList.pop();
      }
      this.currentModel.importFile = fileList.slice(-1);
    }
  onRemove (file, fileList) {
    this.currentModel.importFile = fileList;
    this.tableData=[];
      this.fileId="";
  }
  onSuccess(response,file,fileList){
    let result=response.result;
    if(result.id!=''&&result.sheets){
      this.tableData=result.sheets;
      this.fileId=result.id;
    }
  }
  cancel(){
      (this.$refs[this.formRef] as any).resetFields();
      this.tableData=[];
          this.$emit('input',false);
  }
  async downloadImportTemplate(){
      let response = await this.$store.dispatch({
          type: "auditfiles/downloadImportTemplate",
           data: {id:'BankInfoTemplate.xlsx',filename:'导入银行函证清单模板.xlsx'}
       });
  }
  async save() {
    if (this.currentModel.importFile.length > 0) {
        this.loading=true;
        let sheets=(this.$refs['sheetTable'] as any).selection;
        if(sheets.length>0)
        {
          let arrs="";
          for(var k=0;k<sheets.length;k++){
             if(k==0)
             {arrs=sheets[k].sheetIndex;}
             else{
              arrs=arrs+','+sheets[k].sheetIndex;
             }
          }
          let currid=this.$store.state.jobdo.currjob;
            let result = await this.$store.dispatch({
              type: "hzbletter/importHzbInfoExcel",
              data:{Id:currid,FileId:this.fileId,IndexArrs:arrs,IsAdd:this.rdoImport}
            });
            if (result) {
              if(result.status=="ok"){
                   this.currentModel = { importFile: [] };
                  this.tableData=[];
                  this.loading=false;
                  this.$Message.success("导入成功");
                  (this.$refs[this.formRef] as any).resetFields();
                  this.$emit('save-success');
                  this.$emit('input',false);
              }
              else{
                  this.$Modal.error({
                  title: this.L("SystemFailed"),
                  content: result.message
                  });
                  this.loading=false;
              }
            }else{
               this.$Modal.error({
                  title: this.L("SystemFailed"),
                  content: '程序未响应'
                  });
                  this.loading=false;
            }
        }
        else{
          this.$Message.info("至少勾选一个Sheet表.");
          this.loading=false;
        }

			
      } else {
        this.$message.error('请先选择上传文件');
        this.loading=false;
      }
  }
}
